import { queryOptions } from '@tanstack/react-query'
import { apiGet, apiPost, type PostValue } from './client'

/**
 * Settings -> AGENT SETTINGS -> Install Options, calea noua.
 *
 * Perechile vechi - citirea si scrierile stau in DOUA controllere de portal,
 * fiindca fila e desenata de rail-ul lui Companies dar salvata de
 * `settings/Agent.php`:
 *
 *   Companies::install_options           -> GET  /settings/install_options
 *   Agent::update_general_settings       -> POST /settings/install_options/general
 *   Agent::update_visual_install_options -> POST /settings/install_options/visual
 *
 * Fiecare scriere raspunde cu ECRANUL INTREG. In portal, `ajaxForm` nu citea
 * nimic inapoi: ecranul ramanea cu ce era tastat, care putea sa nu fie ce s-a
 * scris (culoarea goala cade pe `#DDDDDD`, si asta nu se vedea pana la
 * urmatoarea deschidere).
 */

export type SettingsTab = {
  id: string
  label: string
  icon: string
  href: string
  right: string
  group: string
}

export type AgentInstallConfig = {
  /** it_agent_default_install_options.auto_update */
  auto_update: boolean
  /** firma.enable_agent_uninstall - singura bifa care NU sta in tabela de optiuni */
  enable_agent_uninstall: boolean
  hide_on_system_tray: boolean
  create_shortcut_on_desktop: boolean
  /** `#RGB` sau `#RRGGBB`; serverul refuza orice altceva. */
  main_color: string
}

export type AgentInstallShell = {
  pageTitle: string
  moduleUrl: string
  tabs: SettingsTab[]
  /** `settings.my_company.edit`. In portal scrierea nu cerea NICIUN drept. */
  canWrite: boolean
  companyName: string
  /** Fals = firmei nu i s-a scris inca niciun rand de optiuni. */
  exists: boolean
  settings: AgentInstallConfig
}

export const agentInstallShellQuery = queryOptions({
  queryKey: ['settings', 'install_options'],
  queryFn: () => apiGet<AgentInstallShell>('/settings/install_options'),
})

export function saveAgentInstallGeneral(fields: Record<string, PostValue>) {
  return apiPost<AgentInstallShell & { saved: boolean }>('/settings/install_options/general', fields)
}

export function saveAgentInstallVisual(fields: Record<string, PostValue>) {
  return apiPost<AgentInstallShell & { saved: boolean }>('/settings/install_options/visual', fields)
}
